<template>
    <div class="d-flex align-items-start align-items-md-stretch flex-wrap">
        <div class="col-6 col-xl-4">
            <router-link to="/dashboard/travels/tickets" class="text-decoration-none" :class="{'disabled' : BankCards && BankCards.length === 0}">
                <card :class="{'disabled' : BankCards && BankCards.length === 0}">
                    <template v-slot:body>
                        <div class="d-flex flex-wrap">
                            <div class="col-12 text-center">
                                <DashboardIcon :icon="'tickets'" class="dashboard-icon"/>
                            </div>
                            <div class="col-12 text-center mt-4">
                                <h5 class="text-third">
                                    {{ $t('Dashboard.DashboardIndex.Cards.Tickets') }}
                                </h5>
                            </div>
                        </div>
                    </template>
                </card>
            </router-link>
        </div>
        <div class="col-6 col-xl-4">
            <router-link to="/dashboard/travels/payments" class="text-decoration-none" :class="{'disabled' : BankCards && BankCards.length === 0}">
                <card :class="{'disabled' : BankCards && BankCards.length === 0}">
                    <template v-slot:body>
                        <div class="d-flex flex-wrap">
                            <div class="col-12 text-center">
                                <DashboardIcon :icon="'payments'" class="dashboard-icon"/>
                            </div>
                            <div class="col-12 text-center mt-4">
                                <h5 class="text-third">
                                    {{ $t('Dashboard.DashboardIndex.Cards.Payments') }}
                                </h5>
                            </div>
                        </div>
                    </template>
                </card>
            </router-link>
        </div>
        <div class="col-6 col-xl-4 position-relative">
            <router-link to="/dashboard/travels/bank_cards" class="text-decoration-none">
                <card>
                    <template v-slot:body>
                        <div class="d-flex flex-wrap">
                            <div class="col-12 text-center">
                                <DashboardIcon :icon="'bankcard'" class="dashboard-icon"/>
                            </div>
                            <div class="col-12 text-center mt-4">
                                <h5 class="text-third">
                                    {{ $t('Dashboard.DashboardIndex.Cards.BankCards') }}
                                    <span class="text-second fw-bold ms-2" v-if="BankCards">
                                        {{ BankCards.length }}
                                    </span>
                                </h5>
                            </div>
                        </div>
                    </template>
                </card>
                <span class="badge badge-alert bg-white border-third text-second fs-4" v-if="BankCards && BankCards.length === 0">
                    <i class="fa-solid fa-exclamation"></i>
                </span>
            </router-link>
        </div>
        <div class="col-6 col-xl-4">
            <router-link to="/" class="text-decoration-none disabled">
                <card class="disabled">
                    <template v-slot:body>
                        <div class="d-flex flex-wrap">
                            <div class="col-12 text-center">
                                <DashboardIcon :icon="'subscriptions'" class="dashboard-icon"/>
                            </div>
                            <div class="col-12 text-center mt-4">
                                <h5 class="text-third">
                                    {{ $t('Dashboard.DashboardIndex.Cards.Subscriptions') }}
                                </h5>
                            </div>
                        </div>
                    </template>
                </card>
            </router-link>
        </div>
        <div class="col-6 col-xl-4">
            <router-link to="/dashboard/account" class="text-decoration-none">
                <card>
                    <template v-slot:body>
                        <div class="d-flex flex-wrap">
                            <div class="col-12 text-center">
                                <DashboardIcon :icon="'account'" class="dashboard-icon"/>
                            </div>
                            <div class="col-12 text-center mt-4">
                                <h5 class="text-third">
                                    {{ $t('Dashboard.DashboardIndex.Cards.Account') }}
                                </h5>
                            </div>
                        </div>
                    </template>
                </card>
            </router-link>
        </div>
        <div class="col-6 col-xl-4">
            <card @click="this.$store.dispatch('logout')">
                <template v-slot:body>
                    <div class="d-flex flex-wrap">
                        <div class="col-12 text-center">
                            <DashboardIcon :icon="'logout'" class="dashboard-icon"/>
                        </div>
                        <div class="col-12 text-center mt-4">
                            <h5 class="text-third">
                                {{ $t('Dashboard.DashboardIndex.Cards.logout') }}
                            </h5>
                        </div>
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import Card from '@/components/Card.vue'
import DashboardIcon from '@/components/DashboardIcon.vue'
export default {
    name: 'DashboardIndex',
    components: {
        Card,
        DashboardIcon
    },
    computed: {
        ...mapState(['account']),
        ...mapGetters(['apiPath', 'omsApiKey'])
    },
    data() {
        return {
            BankCards: null
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer', 'setLoader', 'setBankCards']),
        async getBankCards() {
            this.setLoader(true)
            try {
                const res = await this.$http.post(`${this.apiPath}/bank_cards/get`,
                {
                    accounts_id: this.account.id
                }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                this.setLoader(false)
                return res.data

            } catch (err) {
                this.setErrorFromServer(err.message)
                this.setLoader(false)
            }
        }
    },
    async mounted() {
        this.BankCards = await this.getBankCards()
    }
}
</script>